import { useLocation, Link } from "react-router-dom";

export function BottomNav() {
  const location = useLocation();
  const currentPath = location.pathname;

  const tabs = [
    {
      label: "Home",
      path: "/",
      icon: (active: boolean) => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"} stroke="currentColor" strokeWidth={active ? "0" : "2"}>
          {active ? (
            <path d="M3 10.5L12 3L21 10.5V20C21 20.5523 20.5523 21 20 21H15V15H9V21H4C3.44772 21 3 20.5523 3 20V10.5Z" />
          ) : (
            <path d="M3 10.5L12 3L21 10.5V20C21 20.5523 20.5523 21 20 21H15V15H9V21H4C3.44772 21 3 20.5523 3 20V10.5Z" />
          )}
        </svg>
      ),
    },
    {
      label: "Chat",
      path: "/chat",
      icon: (active: boolean) => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"} stroke="currentColor" strokeWidth={active ? "0" : "1.5"}>
          {active ? (
            <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"/>
          ) : (
            <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"/>
          )}
        </svg>
      ),
    },
    {
      label: "Insights",
      path: "/insights",
      icon: (active: boolean) => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"} stroke={active ? "none" : "currentColor"} strokeWidth="1.5">
          {active ? (
            <>
              <circle cx="12" cy="12" r="10" fill="currentColor"/>
              <path d="M12 2V12L18.9 17.5" stroke="white" strokeWidth="2" fill="none"/>
            </>
          ) : (
            <>
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 2V12L18.9 17.5"/>
            </>
          )}
        </svg>
      ),
    },
  ];

  return (
    <nav className="flex items-center justify-around pt-2 pb-safe border-t border-[#e8e4db] bg-[#fdfcfa]">
      {tabs.map((tab) => {
        const isActive = tab.path === "/" ? currentPath === "/" : currentPath.startsWith(tab.path);
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`flex flex-col items-center gap-1 py-2 px-6 ${
              isActive ? "text-[#2d4739]" : "text-[#8a8a8a]"
            }`}
          >
            {tab.icon(isActive)}
            <span className={`text-xs ${isActive ? "font-medium" : ""}`}>
              {tab.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
